import { canWrite } from '@/auth/writeKeys';
import { can, isCustomerContext } from '@/utils/userRole';

/**
 * Edit Theme access (authorization part 7j).
 *
 * The theme belongs to the active customer context (brand, right holder, agency; the gateway
 * answers 403 to an INTERNAL context). The gateway reads the theme without a key and accepts
 * every theme write (palette, theme mode, font, font upload, font reset) only with edit_theme.
 *
 * - The page and its Settings link open with view_theme_screen (view the settings, read only)
 *   or edit_theme (a role that may change the theme can also open it).
 * - Every save control needs edit_theme; without it the page is read only.
 */
export const canOpenThemeEditor = (): boolean =>
  isCustomerContext() && (can('view_theme_screen') || canWrite('themeEdit'));

/** True when the gateway would accept a theme write from the active role. */
export const canSaveTheme = (): boolean => isCustomerContext() && canWrite('themeEdit');
